import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UtilityService } from '@irb-common/services/utility.service';
import { interval, Subscription } from 'rxjs';
import { AppService } from '@irb/app.service';

@Injectable({
  providedIn: "root",
})
export class IrbAuthenticationService {
  httpOptions: any;
  authTokenSubscription: Subscription;
  token: string;

  constructor(private _http: HttpClient, private util: UtilityService, private as: AppService) {
    const env = this.util.getEnv();

    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Schwab-Client-CorrelId": this.util.generateSchwabUUID(),
        "Schwab-Resource-Version": "1",
        "Schwab-Client-AppId": "AD00007808",
        "Referrer-Policy": "no-referrer",
        "Cache-Control": "no-cache",
        "Accept": "application/json",
        "Vary": "Origin",
        "Pragma": "no-cache",
        "Expires": "Sat, 01 Jan 2000 00:00:00 GMT",
        "Schwab-Gateway-Scope": "AdvisorCenter",
        "Schwab-Env": env
      }),
    };
  }

  hasToken(): boolean {
    return typeof this.token !== "undefined";
  }

  getAuthToken() {
    this.getToken().subscribe((res: any) => {
      this.token = res.EAT;
      this.tokenValidateAndSet("Bearer " + this.token);
    }, () => {
      this.handleTokenError();
    });
  }

  handleTokenError() {
    this.as.logOut();
  }

  startAuthTokenSubscription(cbFunc: Function) {
    let i = (this.util.getEnv() === 'PROD') ? 30 : 8;

    this.authTokenSubscription = interval(60000 * i).subscribe(() => {
      cbFunc()
    });
  }

  tokenValidateAndSet(token: string) {
    if (typeof token !== "undefined") {
      window.sessionStorage.setItem("IRB_AUTH_TOKEN", window.btoa(token));
      return true;
    } else if (window.sessionStorage.getItem("IRB_AUTH_TOKEN") && this.as.getItem("IRB_APP_CONFIG")) {
      return true;
    } else {
      return false;
    }
  }

  setGatewayURL(url: string) {
    window.sessionStorage.setItem("IRB_GATEWAY_URL", window.btoa(url));
  }

  setSacContextGatewayURL(url: string) {
    window.sessionStorage.setItem("IRB_SAC_CONTEXT_GATEWAY_URL", window.btoa(url));
  }

  getToken(): Observable<Object> {
    return this._http.get("/getEAT", this.httpOptions);
  }

  getDetailForInitialLoad(): Observable<Object> {
    return this._http.get('/irebalone/sso/get-detail-for-initial-load', this.httpOptions);
  }

  getAppConfigDetails(): Observable<Object> {
    return this._http.get('/irebalone/home-page/get-initial-detail', this.httpOptions);
  }

  validateToken(): Observable<Object> {
    return this._http.post("/irebalAuthService/", this.httpOptions);
  }

  getIrebalDLCookie() {
    return this.util.getCookie('irebal-dl');
  }

  deleteIrebalDLCookie() {
    this.util.deleteCookie('irebal-dl');
  }
}
